export {};
//# sourceMappingURL=transform-metadata.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/class-transformer/esm5/interfaces/metadata/transform-metadata.interface.js
// module id = 799
// module chunks = 3